// Notification action types
export const DISPLAY_SUCCESS_NOTIFICATION = 'DISPLAY_SUCCESS_NOTIFICATION';
export const DISPLAY_ERROR_NOTIFICATION = 'DISPLAY_ERROR_NOTIFICATION';
export const DISPLAY_INFO_NOTIFICATION = 'DISPLAY_INFO_NOTIFICATION';